import { isBoolean as _isBoolean, isObject as _isObject } from 'lodash';

const handleIsLoading = isLoading => {
  let isLoadingDiscover = false;
  let isLoadingDashboard = handleIsLoadingCards(false);
  if (_isBoolean(isLoading)) {
    isLoadingDiscover = isLoading;
    isLoadingDashboard = handleIsLoadingCards(isLoading);
  } else if (_isObject(isLoading)) {
    if (_isBoolean(isLoading.dashboard)) {
      isLoadingDashboard = handleIsLoadingCards(isLoading.dashboard);
    } else {
      isLoadingDashboard = isLoading.dashboard;
    }
    isLoadingDiscover = isLoading.discover;
  }
  return { isLoadingDiscover, isLoadingDashboard };
};

const handleIsLoadingCards = isLoading => {
  return {
    isLoadingMainCard: isLoading,
    isLoadingSecondaryCard: isLoading,
    isLoadingThirdCard: isLoading,
    isLoadingFourthCard: isLoading,
  };
};

export { handleIsLoading, handleIsLoadingCards };
export default handleIsLoading;
